<template>
  <el-card>
    <el-row type="flex" justify="space-between" ref="barparent">
      <div class="flex_wrap">
        <div class="flex_box_center">
          <span>开始日期&nbsp;&nbsp;</span>
          <el-date-picker v-model="query.startDate" :picker-options="pickerOptionsStart" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 68%"></el-date-picker>
        </div>

        <div class="flex_box_center">
          &nbsp;&nbsp;
          <span>结束日期&nbsp;&nbsp;</span>
          <el-date-picker v-model="query.endDate" :picker-options="pickerOptionsEnd" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 68%"></el-date-picker>
        </div>

        <div class="flex_box_center">
          &nbsp;&nbsp;
          <span style="display: inline-block; width: 120px">单位名称&nbsp;&nbsp;</span>
          <el-input v-model="query.corpName" oninput="value=value.toUpperCase()" placeholder="输入单位名称模糊搜索" @change="handleQueryLike"></el-input>
        </div>
      </div>
      <div style="margin: 6px 10px; min-width: 200px; text-align: right; font-size: 14px">
        <el-button style="margin: 6px 10px" size="small" @click="hanleQuery" type="primary">查询</el-button>
        <el-button type="primary" size="small" @click="handlePrint('print')">打印</el-button>
        <el-button type="primary" size="small" @click="handlePrint('preview')">打印预览</el-button>
        <el-button type="primary" size="small" v-if="isExport" @click="handleExport">导出</el-button>
      </div>
    </el-row>
  </el-card>
</template>

<script>
import DateUtils from '@/utils/DateUtils';

export default {
  props: {
    title: {
      type: String,
    },
    data: {
      type: Object,
    },
    isAll: {
      type: Boolean,
    },
    isFood: {
      type: Boolean,
      default: false,
    },
    isdel: {
      type: Boolean,
      default: true,
    },
    isExport: {
      type: Boolean,
      default: true,
    },
    isDay: {
      type: Boolean,
      default: true,
    },
    isSales: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [],
      salePersonList: [],
      query: {
        startDate: DateUtils.formatDate(new Date(), 'yyyy-MM-dd'),
        endDate: DateUtils.formatDate(new Date(), 'yyyy-MM-dd'),
        corpName: '',
      },
      pickerOptionsStart: {
        disabledDate: time => {
          let delay = this.query.endTime;
          if (delay) {
            return time.getTime() > new Date(delay).getTime();
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let delay = this.query.startTime;
          if (delay) {
            return time.getTime() < new Date(delay).getTime() - 3600 * 1000 * 24;
          }
        },
      },
      queryShiftValue: '',
      queryParams: undefined,
      resetReport: false,
      newWindow: false,
      marketingEmployees: [],
      agreements: [],
      outletsListArr: [],
      bookByOutletsArr: [],
      foodTypeByBooksArr: [],
      interval: false,
      loadingButton: false,
    };
  },
  created() {
    this.getEmpLists();
  },
  methods: {
    handleShift(value) {
      this.$bus.$emit('renderQueryShiftValue', value);
    },
    getEmpLists() {
      //获取操作员工

      let url = this.api.getListMap,
        methods = 'get';
      this.$axios({
        url,
        methods,
      }).then(response => {
        if (response.data.status === 0) {
          this.options = response.data.data;
          console.log(this.options, 'this.options');
        }
      });
      // 控制营业点
      url = this.api.getoutlets;
      let data = {
        posCode: localStorage.getItem('posCode'),
      };
      this.$axios({
        url,
        methods,
        data,
      }).then(res => {
        if (res.data.status === 0) {
          this.outletsListArr = res.data.data;
        }
      });
      url = this.api.bookByOutlets;
      this.$axios({
        url,
        methods,
      }).then(res => {
        if (res.data.status === 0) {
          this.bookByOutletsArr = res.data.data;
        }
      });

      url = this.api.foodTypeByBooks;
      this.$axios({
        url,
        methods,
      }).then(res => {
        if (res.data.status === 0) {
          this.foodTypeByBooksArr = res.data.data;
        }
      });
    },
    changeOutletId(val) {
      console.log(11, val);
      let outletIds = val.join(',');
      let data = {
        outletIds: val.join(','),
      };
      this.query.foodBookIds = [];
      this.query.foodTypeIds = [];
      url = this.api.bookByOutlets;
      this.$axios({
        url,
        methods,
        data,
      }).then(res => {
        if (res.data.status === 0) {
          this.bookByOutletsArr = res.data.data;
        }
      });
    },
    changeBookByOutlets(val) {
      this.query.foodTypeIds = [];
      let foodBookIds = val.join(',');
      let data = {
        foodTypeByBooks: val.join(','),
      };

      url = this.api.foodTypeByBooks;
      this.$axios({
        url,
        methods,
        data,
      }).then(res => {
        if (res.data.status === 0) {
          this.foodTypeByBooksArr = res.data.data;
        }
      });
    },
    changefoodTypeByBooks(val) {},
    handleQueryLike(e) {
      this.query.corpName = e;
    },
    hanleQuery() {
      this.$bus.$emit('todoQuery', this.query);
      this.$bus.$emit('outletsListArr', this.outletsListArr);
      this.$bus.$emit('options', this.options);
    },
    //打印
    handlePrint(type) {
      this.$bus.$emit('todoPrintCatering', type);
    },
    handleExport() {
      this.$bus.$emit('todoExportCatering');
    },
  },
};
</script>

<style lang="scss" scoped>
.el-card {
  width: 100%;

  .flex_wrap {
    flex-wrap: nowrap;
    margin-top: 10px;
  }
  .flex_box_center {
    font-size: 14px;
  }
}
</style>
